export enum E2EPhonePlanIdsEnum {
  REWRITES_PHONE_PLAN = 2,
}
